export default "__VITE_ASSET__CbPI9Xa6__"